<div class="seperator"></div>

<div class="main-slip-container" *ngFor="let matchArray of slipDetailList | groupByKeyPipe : 'MatchId' | sortBy : false : 'EventDateIso'">
  <ng-container *ngFor="let match of matchArray.eEvents; let indexMatch = index; let last = last">
    <div class="main-box" *ngIf="indexMatch == 0" (click)="goMatchDetail(match)">
      <div class="main-slip-container-left">
        <div class="left-box">
          <div class="banko" *ngIf="match.Banko == 1">B</div>
          <div class="match-info">
            <div class="match-name">{{ match.HomeTeam }}</div>
            <div class="match-name">{{ match.AwayTeam }}</div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!getLiveEvent(match.BetradarMatchId)">
        <div class="main-slip-container-right">
          <div class="live-box">
            <span *ngIf="match.Result !== '-'">{{ match.Result?.split(' ')[0] }}</span>
          </div>
          <div class="right-box">
            <div class="score-info">
              <div class="score-match">
                {{ match.Result.split(' ')[2]?.split(':')[0] }}
                <ng-container *ngIf="match.Result === '-'">
                  <span style="font-weight: 400">
                    {{ (match.EventDateIso | dateFormat : 'dd-MM') == (this.today | dateFormat : 'dd-MM') ? ('today' | t) : (match.EventDateIso | dateFormat : 'dd.MM') }}
                  </span>
                </ng-container>
              </div>
              <div class="score-match">
                {{ match.Result.split(' ')[2]?.split(':')[1] }}
                <ng-container *ngIf="match.Result === '-'">
                  <span style="font-weight: 400">
                    {{ match.EventDateIso | dateFormat : 'H:mm' }}
                  </span>
                </ng-container>
              </div>

              <!-- İlk yarı Skorları için hazırlandı  -->

              <!-- <div class="score-first-half-info">
                <div class="score-first-half">
(1)
                </div>
                <div class="score-first-half">
(2)
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="getLiveEvent(match.BetradarMatchId) as eventObj">
        <div class="main-slip-container-right">
          <div class="live-box">
            {{ eventObj.TimeStatu == 3 || eventObj?.SportName === 'Tennis' ? eventObj.TimeStatuColor : eventObj.MatchTime === '' ? eventObj.TimeStatuColor : eventObj.MatchTime }}
          </div>
          <div class="right-box">
            <div class="score-info">
              <div class="score-match">{{ eventObj.Score.split(':')[0] }}</div>
              <div class="score-match">{{ eventObj.Score.split(':')[1] }}</div>
            </div>

            <!-- İlk yarı Skorları için hazırlandı  -->
            <!-- <div class="score-first-half-info">
              <div class="score-first-half">
(1)
              </div>
              <div class="score-first-half">
(2)
              </div>
            </div> -->

            <div class="statu"></div>
            <div class="score"></div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="match-detail-row type">
      <div class="detail-left">
        {{ match.OddsType }} {{ match.SpecialBetValue }} - Tip:
        <b>
          {{ match.Outcomes }}
        </b>
      </div>

      <div class="detail-right">
        <image-loader-utils *ngIf="match.StateId == 3 || match.StateId == 2" url="check-circle" extraClasses="check-circle-icon won"></image-loader-utils>
        <image-loader-utils *ngIf="match.StateId == 4" url="times-circle" extraClasses="check-circle-icon lost"></image-loader-utils>
        {{ match.OddValue }}
      </div>
    </div>

    <div class="match-detail-row type" *ngIf="match.betPlacement && match.betPlacement !== '' && last">
      <div class="detail-full">
        {{ 'b3000_score' | t }} :
        {{ match.betPlacement }}
      </div>
    </div>
  </ng-container>
  <div class="seperator"></div>
</div>

<ng-template #nocashout>
  <div class="slip-info" *ngFor="let item of this.couponDetailList">
    <div class="slip-left-side">
      <div class="slip-left-row">{{ 'betsID' | t }}</div>
      <div class="slip-left-row">{{ 'price' | t }}</div>

      <div class="slip-left-row">{{ 'Total_Stake_:' | t }}</div>
      <div class="slip-left-row">{{ 'b3000_Fee' | t }}:</div>
      <div class="slip-left-row">{{ 'Stake_per_Bet' | t }}:</div>

      <div class="slip-left-row">{{ 'Number_Of_Bets' | t }}:</div>
      <div class="slip-left-row">{{ 'b3000_Max_Odds' | t }}:</div>
      <div class="slip-left-row">{{ 'Possible_winnings' | t }}:</div>
      <div class="slip-left-row">{{ 'Won' | t }}:</div>
    </div>
    <div class="slip-right-side">
      <div class="slip-right-row">{{ item.SlipId }}</div>
      <div class="slip-right-row">
        {{ item.Amount * 1 + item.TaxAmount | number : '1.2-2' }}
        {{ _UserHelper.customerUser?.Symbol }}
      </div>

      <div class="slip-right-row">{{ item.Amount }} {{ _UserHelper.customerUser?.Symbol }}</div>
      <div class="slip-right-row">
        {{ item.TaxAmount | number : '1.2-2' }}
        {{ _UserHelper.customerUser?.Symbol }}
      </div>
      <div class="slip-right-row">
        {{ item.EventPerAmount | number : '1.2-2' }}
        {{ _UserHelper.customerUser?.Symbol }}
      </div>

      <div class="slip-right-row">{{ item.Bets }}</div>
      <div class="slip-right-row">{{ item.TotalOddValue }} {{ _UserHelper.customerUser?.Symbol }}</div>
      <div class="slip-right-row">{{ item.PosibbleGain }} {{ _UserHelper.customerUser?.Symbol }}</div>

      <div class="slip-right-row">{{ item.Gain }} {{ _UserHelper.customerUser?.Symbol }}</div>
    </div>
  </div>
</ng-template>
<div *ngIf="couponDetailList[0]?.SlipState.toLowerCase() == 'cash========================================out'; else nocashout">
  <div class="slip-info cashout" *ngFor="let item of this.couponDetailList">
    <div class="slip-left-side">
      <div class="slip-left-row">{{ 'betsID' | t }}</div>
      <div class="slip-left-row">{{ 'price' | t }}</div>

      <div class="slip-left-row">{{ 'Total_Stake_:' | t }}</div>
      <div class="slip-left-row">{{ 'b3000_Fee' | t }}:</div>
      <div class="slip-left-row">{{ 'Stake_per_Bet' | t }}:</div>
      <div class="slip-left-row">{{ 'Number_Of_Bets' | t }}:</div>
      <div class="slip-left-row">{{ 'b3000_Max_Odds' | t }}:</div>
      <div class="slip-left-row">{{ 'Possible_winnings' | t }}:</div>
      <div class="slip-left-row">{{ 'Won' | t }}:</div>

      <div class="slip-left-row">{{ 'CashoutTime' | t }}:</div>
      <div class="slip-left-row">{{ 'CashoutOffer' | t }}:</div>
      <div class="slip-left-row">{{ 'CashoutAmount' | t }}:</div>
      <div class="slip-left-row">{{ 'RestOfStake' | t }}:</div>
      <div class="slip-left-row">{{ 'newStake' | t }}:</div>
      <div class="slip-left-row">{{ 'Possible_winnings' | t }}:</div>

      <div class="slip-left-row">{{ 'fullCashout' | t }}:</div>
    </div>
    <div class="slip-right-side">
      <div class="slip-right-row">{{ item.SlipId }}</div>

      <div class="slip-right-row">
        {{ item.Amount * 1 + item.TaxAmount | number : '1.2-2' }}
        {{ _UserHelper.customerUser?.Symbol }}
      </div>

      <div class="slip-right-row">{{ item.Amount }} {{ _UserHelper.customerUser?.Symbol }}</div>
      <div class="slip-right-row">
        {{ item.TaxAmount | number : '1.2-2' }}
        {{ _UserHelper.customerUser?.Symbol }}
      </div>
      <div class="slip-right-row">
        {{ item.EventPerAmount | number : '1.2-2' }}
        {{ _UserHelper.customerUser?.Symbol }}
      </div>

      <div class="slip-right-row">{{ item.Bets }}</div>
      <div class="slip-right-row">{{ item.TotalOddValue }}</div>
      <div class="slip-right-row">{{ item.PosibbleGain }} {{ _UserHelper.customerUser?.Symbol }}</div>

      <div class="slip-right-row">{{ item.Gain }} {{ _UserHelper.customerUser?.Symbol }}</div>

      <div class="slip-right-row">
        {{ item.EvaluateDate | dateFormat : 'dd/MM/yyyy H:mm' }}
      </div>
      <div class="slip-right-row">0 {{ _UserHelper.customerUser?.Symbol }}</div>
      <div class="slip-right-row">0 {{ _UserHelper.customerUser?.Symbol }}</div>
      <div class="slip-right-row">0 {{ _UserHelper.customerUser?.Symbol }}</div>

      <div class="slip-right-row">{{ item.Gain }} {{ _UserHelper.customerUser?.Symbol }}</div>
      <div class="slip-right-row">{{ item.Gain }} {{ _UserHelper.customerUser?.Symbol }}</div>
    </div>
  </div>
</div>

<div *ngIf="inputStateId == 1" class="btn colored register-button save-changes-button confirm-button" (click)="slipRestoreB3000()">
  <div class="restore-slip-text">{{ 'slipdetail_re_use_slip' | t }}</div>
</div>
